<template>
  <div class="check-export-data">
    <div class="check-area">
      <header class="check-header"><h3>下载报告</h3></header>
      <main class="check-body">
        <div class="check-item">
          <h3 class="check-item-name">图表来源:</h3>
          <CheckboxGroup
            :options="typeList"
            @handleCheckedChange="handleCheckedChange"
          ></CheckboxGroup>
        </div>
        <!-- <div class="check-item">
          <h3 class="check-item-name">图片来源:</h3>
          <CheckboxGroup
            :options="typeList"
            :selectedTypeList="selectedTypeList"
            @handleCheckedChange="handleCheckedChange"
          ></CheckboxGroup>
        </div>
        <div class="check-item">
          <h3 class="check-item-name">图片来源:</h3>
          <CheckboxGroup
            :options="typeList"
            :selectedTypeList="selectedTypeList"
            @handleCheckedChange="handleCheckedChange"
          ></CheckboxGroup>
        </div>
        <div class="check-item">
          <h3 class="check-item-name">图片来源:</h3>
          <CheckboxGroup
            :options="typeList"
            :selectedTypeList="selectedTypeList"
            @handleCheckedChange="handleCheckedChange"
          ></CheckboxGroup>
        </div> -->
      </main>
      <footer class="check-footer">
        <el-button type="primary" class="export-commit" @click="handleExport">确认</el-button>
        <el-button type="primary" class="export-cancel" @click="$emit('cancelExportImgs')"
          >取消</el-button
        >
      </footer>
    </div>
  </div>
</template>

<script>
import CheckboxGroup from "../CheckboxGroup"
export default {
  props: {
    typeList: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    CheckboxGroup,
  },
  data() {
    return {
      selectedList: [...this.typeList],
    }
  },
  methods: {
    handleExport() {
      this.$emit("handleExport", this.selectedList)
    },
    handleCheckedChange(params) {
      this.selectedList = [...params]
    },
  },
}
</script>

<style lang="scss" scoped>
$innerLight: rgba(
  $color: #bce6ec,
  $alpha: 0.5,
);
$fontColor: #eee;
.check-export-data {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: transparent;
  backdrop-filter: blur(5px);
  z-index: 999;

  & .check-area {
    color: $fontColor;
    background-color: #030b32;
    border-radius: 5px;
    overflow: hidden;
    height: 50%;
    width: 40%;
    border: 1px solid rgb(43, 57, 87, 0.4);
    .check-header {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      height: 5%;
      box-sizing: border-box;
      background-color: rgba($color: #0b183d, $alpha: 1);
      box-shadow: 0 0 0.5em $innerLight inset;
    }
    & .check-body {
      height: 85%;
      background-color: transparent;
      overflow: auto;
      padding: 0 10px;
      .check-item {
        .check-item-name {
          font-weight: normal;
          margin-bottom: 1%;
        }
        margin-top: 1%;
      }
      &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #293e79;
        border-radius: 3px;
      }
      &::-webkit-scrollbar-track {
        background-color: #0f1d44;
        border-radius: 3px;
      }
    }
    & .check-footer {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      height: 10%;
      background-color: transparent;
      box-sizing: border-box;
      .el-button--primary {
        background-color: transparent;
        border: 1px solid rgb(43, 57, 87, 0.4);
      }
      .el-button--primary:hover {
        background-color: #293e79;
      }
      & .export-commit,
      & .export-cancel {
        padding: 1vh 0.8vw;
      }
    }
    // padding: 10px;
  }
}
</style>
